import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';

// import Circular from './Circularprogress';
// import Modalopener from './Modal.jsx';
// import Menuname from './Supplymenu.jsx';
import Nodata from '../pages/nodatafound.jsx';

import Circular from '../components/Circularprogress.jsx';
import Modalopener from '../modal/Modal.jsx';
import Modalviewer from '../modal/Modalview.jsx';
import Modaldelete from '../modal/Modaldelete.jsx';
import Modalediter from '../modal/Modaledit.jsx';
import Modalapproveer from '../modal/Modalapprove.jsx';
import Modalretireer from '../modal/Modalretire.jsx';
import Modalpayouter from '../modal/Modalpayout.jsx';
import Menuname from '../menu/menuexpenses.jsx';
import { formatGHC } from '../helper/ToastNotify';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin.jsx';
import { getservice } from '../redux/service.jsx';
import { getexpenses } from '../redux/expenses.jsx';



import { Modal } from '@mui/material';

function createData(id, description, amount, requester, date, payment, type, pv, status , reasons) {
  return {
    id, description, amount, requester, date, payment, type, pv, status, reasons
  };
}

var rows = [
  createData(1, 'Cupcake', 305, 3.7, 67, 4.3),
  createData(2, 'Donut', 452, 25.0, 51, 4.9),
  createData(3, 'Eclair', 262, 16.0, 24, 6.0),
  createData(4, 'Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData(5, 'Gingerbread', 356, 16.0, 49, 3.9),
  createData(6, 'Honeycomb', 408, 3.2, 87, 6.5),
  createData(7, 'Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData(8, 'Jelly Bean', 375, 0.0, 94, 0.0),
  createData(9, 'KitKat', 518, 26.0, 65, 7.0),
  createData(10, 'Lollipop', 392, 0.2, 98, 0.0),
  createData(11, 'Marshmallow', 318, 0, 81, 2.0),
  createData(12, 'Nougat', 360, 19.0, 9, 37.0),
  createData(13, 'Oreo', 437, 18.0, 63, 4.0),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: 'Date',
  },  {
    id: 'purpose',
    numeric: false,
    disablePadding: false,
    label: 'Purpose',
  },
  {
    id: 'paidto',
    numeric: false,
    disablePadding: false,
    label: 'Paid To',
  },{
    id: 'Type',
    numeric: false,
    disablePadding: false,
    label: 'Type',
  },{
    id: 'pv',
    numeric: false,
    disablePadding: false,
    label: 'PV Num.',
  },
  {
    id: 'amount',
    numeric: false,
    disablePadding: false,
    label: 'Amount',
  }, {
    id: 'Status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  }, 
 
 
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
    
        {headCells.map((headCell) => (
          <TableCell
          style={{fontWeight:"bolder"}}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]


  
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const expenses = useSelector((state) => state.expenses)
  const agent = useSelector((state) => state.agent)
  var rows_ = [(expenses || []).map((list, index) => createData(list._id, list.description, list.amount, list.requester, list.date, list.payment, list.type, list.pv, list.status || 'Pending', list.reasons))]
  var rows = rows_.length===1 ? rows_[0] :[]

  var datepusher=[]
  const [order, setOrder] = React.useState('asc');
  const [Modalvalue, setModalvalue] = React.useState(false);
  const [Modalview, setModalview] = React.useState(false);
  const [Modalapprove, setModalapprove] = React.useState(false);
  const [Modalpayout, setModalpayout] = React.useState(false);
  const [Modalretire, setModalretire] = React.useState(false);
  const [Modaldeleter, setModaldeleter] = React.useState(false);
  const [Modaledit, setModaledit] = React.useState(false);
  const [Chosen, setChosen] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [search, setsearch] = React.useState("");
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [expenseType, setExpenseType] = React.useState('all');
  // Add Paid To filter state
  const [paidTo, setPaidTo] = React.useState('all');


  const searching = (e) => {
    setsearch(e.target.value)
}

if (search !== "" || startDate || endDate || expenseType !== 'all' || paidTo !== 'all') {
    var listed = rows.filter(bug => {
      const matchesSearch = (bug.name && bug.name.toLowerCase().includes(search.toLowerCase())) ||
        (bug.pv && bug.pv.toLowerCase().includes(search.toLowerCase())) ||
        (bug.type && bug.type.toLowerCase().includes(search.toLowerCase())) ||
        (bug.charge && bug.charge.toLowerCase().includes(search.toLowerCase())) ||
        (bug.description && bug.description.toLowerCase().includes(search.toLowerCase())) ||
        (bug.id && bug.id.toLowerCase().includes(search.toLowerCase()));

      const rowDate = bug.date ? new Date(bug.date) : null;
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      const withinDateRange = (!start || !rowDate || rowDate >= start) && 
                             (!end || !rowDate || rowDate <= end);

      const matchesType = expenseType === 'all' || bug.type === expenseType;

      // Add Paid To filter
      const matchesPaidTo = paidTo === 'all' || bug.requester === paidTo;

      return matchesSearch && withinDateRange && matchesType && matchesPaidTo;
    });
    rows = listed;
}


const totalimprest=()=>{
  var total = 0
  for(var i in rows){
    if(rows[i].type==="imprest"){
      total+= parseFloat(rows[i].amount)
    }
  }
  return formatGHC(total)
}

const totalbalance=()=>{
  var total = 0
  for(var i in rows){
    if(rows[i].type==="imprest"){
      total+= parseFloat(rows[i].amount)
    }else{
      total-= parseFloat(rows[i].amount)
    }
  }
  return formatGHC(total)
}

const totalexpenses=()=>{
  var total = 0
  for(var i in rows){
    if(rows[i].type==="Expenses"){
      total+= parseFloat(rows[i].amount)
    }
  }
  return formatGHC(total)
}

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      [...rows]
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage],
  );

  const showdata=(event, data)=>{
    console.log(data)
    console.log(event)
   
    setModalvalue(true)
 
      
    setChosen(data)

   
  }

  const setoff=()=>{
    setModalvalue(false)
    setModaldeleter(false)
    setModaledit(false)

  }
  const setoffer=()=>{
    setModalview(false)
    setModaldeleter(false)
    setModaledit(false)
    setModalapprove(false)
    setModalpayout(false)
    setModalretire(false)
  }

  
  const setview=()=>{
    console.log("clicked")
    setModalview(true)
    setModalvalue(false)
    
  }
  const setapprove=()=>{
    console.log("clicked")
    setModalapprove(true)
    
  }
  const setpayout=()=>{
    console.log("clicked")
    setModalpayout(true)
    
  }
  const setretire=()=>{
    console.log("clicked")
    setModalretire(true)
    
  }

const setdeleter=()=>{
    console.log("clicked delete")
    setModaldeleter(true)

  }
const setedit=()=>{
    console.log("clicked edit")
    setModaledit(true)

  }

  for(var i=0; i<=11;i++){
    datepusher.push(year-i)

  }

  return (
    <Box sx={{ width: '100%' }}>
    {Modalvalue===true &&  <Modalopener  value={Modalvalue} chosen={Chosen} product={Chosen.name} setfalse={setoff} name="Expenditure"  Menu={<Menuname  name="Expenditure" chosen={Chosen} value={Modalview} view={setview} approve={setapprove} payout={setpayout} retire={setretire} delete={setdeleter} edit={setedit} product={Chosen.name}  />}/>  }
    {Modalview===true &&  <Modalviewer
    
    details={{
      'Type': Chosen.type || 'No type',
      'Amount': formatGHC(Chosen.amount) || 'No amount',
      'PV number': Chosen.pvnumber || 'No PV number',
      'Status': Chosen.status || 'No status',
      'Description': Chosen.description || 'No Description',
      'Payment Mode': Chosen.payment || 'No Payment Mode',
      'Other Info': Chosen.reasons || 'No Other Information',
      
    }}

    name="Expenditure"  product={Chosen.name} chosen={Chosen} view={setview} setfalser={setoffer} value={Modalview}/>}
    {Modaldeleter===true &&  <Modaldelete name="Expenditure" delete={"expenses"} dispatcher={getexpenses}  product={Chosen.name} chosen={Chosen}  view={setdeleter} setfalser={setoffer} value={Modaldeleter}/>}
    {Modaledit===true &&  <Modalediter name="Expenditure"  product={Chosen.name} chosen={Chosen}  view={setedit} setfalser={setoffer} value={Modaledit}/>}
    {Modalapprove===true &&  <Modalapproveer name="Expenditure"  product={Chosen.name} chosen={Chosen}  view={setapprove} setfalser={setoffer} value={Modalapprove}/>}
    {Modalretire===true &&  <Modalretireer name="Expenditure"  product={Chosen.name} chosen={Chosen}  view={setretire} setfalser={setoffer} value={Modalretire}/>}
    {Modalpayout===true &&  <Modalpayouter name="Expenditure"  product={Chosen.name} chosen={Chosen}  view={setpayout} setfalser={setoffer} value={Modalpayout}/>}

      <Paper sx={{ width: '100%', mb: 2 }}>

      <Grid container>
                  
                  <Grid lg={4} xs={2} md={6} style={{textAlign:"center"}}>
                  <p style={{marginLeft:"20px", textAlign:"center",fontSize:"160%", }}> 
  <span>{totalbalance()}</span>  
  <span style={{fontSize:"12px"}}>Balance</span> 
</p>
                  </Grid>
  <Grid lg={4} xs={2} md={6} style={{textAlign:"center"}}>
                  <p style={{marginLeft:"20px", textAlign:"center",fontSize:"160%", }}> 
  <span>{totalimprest()}</span>  
  <span style={{fontSize:"12px"}}>Total Imprest</span> 
</p>
                  </Grid>
  <Grid lg={4} xs={2} md={6} style={{textAlign:"center"}}>
                  <p style={{marginLeft:"20px", textAlign:"center",fontSize:"160%", }}> 
  <span>{totalexpenses()}</span>  
  <span style={{fontSize:"12px"}}>Total Expenses</span> 
</p>
                  </Grid>


                  </Grid>
        <TableContainer>

<div style={{padding:"10px"}}>

<Grid container>
                    <Grid lg={6} xs={2} md={6}>
                        
                    <TextField
                    style={{marginTop:"8px"}}
                    type="date"
                    label="Start Date"
                    value={startDate}
                    size="small"
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
                    type="date"
                    label="End Date"
                    value={endDate}
                    size="small"
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
                    select
                    label="Expense Type"
                    value={expenseType}
                    size="small"
                    onChange={(e) => setExpenseType(e.target.value)}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="all">All Types</option>
                    <option value="imprest">Imprest</option>
                    <option value="Expenses">Expenses</option>
                  </TextField>

                  <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
                    select
                    label="Paid To"
                    value={paidTo}
                    size="small"
                    onChange={(e) => setPaidTo(e.target.value)}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="all">All Agents</option>
                    {agent.map((agentItem) => (
                      <option key={agentItem.idnumber} value={agentItem.idnumber}>
                        {agentItem.surname} {agentItem.othername} {agentItem.lastname}
                      </option>
                    ))}
                  </TextField>



                    </Grid>
                  
                    <Grid lg={3} xs={2} md={6} style={{textAlign:"center"}}>
                      
 <div style={{position:"relative"}}> 
                    <Search id="searchbox"  style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color:"grey" }} /> <input type="search" onChange={(e) => searching(e)} placeholder="Search" style={{ padding: 10, paddingLeft: "38px", marginTop: 10, width: "100%", border: "solid", borderRadius: "5px", borderWidth: "0.5px", backgroundColor: "rgba(65,105,225, 0.05) ", borderColor: "#2196f3" }} />
                    </div> 

                    </Grid>

                    
                    <Grid lg={3} xs={10} md={6}>
                    <p style={{marginLeft:"20px", textAlign:"center",fontSize:"160%", marginTop:"5px"}}> <span>GHC </span> {totalimprest()}  <span style={{fontSize:"12px"}}>Total Imprest</span> </p>

                    </Grid>
                    
                </Grid>

</div>

          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
            {rows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event)=>showdata(event, row)}
                    role="checkbox"
                    // aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell
                    
                      // component="th"
                      id={labelId}
                      scope="row"
                      // padding="normal"
                    >
                      {row.date}
                    </TableCell>
                    <TableCell align="left">{row.description}</TableCell>
                    <TableCell align="left">{(() => {
                      const foundAgent = agent.find(bug => bug.idnumber === row.requester);
                      return foundAgent ? `${foundAgent.surname} ${foundAgent.othername}` : 'Unknown Agent';
                    })()}</TableCell>
                    <TableCell align="left">{row.type}</TableCell>
                    <TableCell align="left">{row.pv}</TableCell>
                    <TableCell align="left">{formatGHC(row.amount || 0)}</TableCell>
                    {/* <TableCell align="left">GHC {row.balance?row.balance:0}</TableCell> */}
                    <TableCell align="left">{row.status}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>

                    {rows.length===0 && <Nodata/>}
          
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[30, 40, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
}
